<template>
  <div>
    <va-card>
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md10 sm6 xs12">
          <h4 style="font-size:24px!important" class="card-title mx-2">CITES</h4>
        </div>
         <div class="flex md2 xs12 sm6">
          <b-button variant="secondary" v-b-modal.modal-footer-sm>
            ADD NEW
            <va-icon style="font-size:22px!important;" name="fa fa-plus-circle" />
          </b-button>
      </div>
      </div>
      <div class="flex md12 xs12 sm6">
        <div style="padding-right:20px!important;" class="d-flex justify--end">
          <b-modal id="modal-footer-sm" title button-size="sm" hide-footer>
            <form @submit="onSubmit">
              <div class="form-group">
                <label for="exampleInputEmail1">ADD NEW CITES</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  v-model="name"
                  required
                  aria-describedby="emailHelp"
                  placeholder="Add New CITES"
                />
              </div>
              <button class="btn btn-success" type="submit">ADD</button>
            </form>
          </b-modal>
        </div>
      </div>
      <div class="container" style="padding-top:20px;">
        <div class="flex md12 sm6 xs12 overflow-auto">
          <div class="overflow-aut0" style="overflow:auto">
            <b-table
              style="padding:40px;"
              hover
              v-if="data.length"
              id="my-table"
              :fields="fields"
              :items="data"
              :per-page="perPage"
              :current-page="currentPage"
              small
              borderless
              head-variant="dark"
              table-variant="light"
            >
               <template v-slot:cell(name)="line">
                <b-form-input
                  style="text-align: center"
                  borderless="true"
                  v-model="line.item.name"
                />
              </template>
              <template v-slot:cell(_id)="data">
                <span style="padding-left:20px!important;">
                  <!-- <router-link :to="'/editcites/'+data.item._id ">
                    <b-button type="submit" variant="info">Update</b-button>
                  </router-link> -->
                      <b-button type="submit" @click="edit(data)" variant="info"
                    >Update</b-button
                  >
                </span>
                <span style="padding-left:20px!important;">
                  <b-button variant="danger" @click="deleteCType(data.item._id)">Delete</b-button>
                </span>
              </template>
            </b-table>
            <p v-else>No Data Found</p>
            <br />
            <b-pagination
              align="center"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
            <br />
          </div>
        </div>
      </div>
    </va-card>
  </div>
</template>
<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  data () {
    return {
      type: '',
      visible: false,
      perPage: '15',
      currentPage: 1,
      name: null,
      msg: '',
      dat: [],
      data: [],
      fields: [
        {
          label: 'CITES',
          key: 'name',
          sortable: false,
          thClass: ' cnt',
          tdClass: 'cnt text-uppercase',
        },
        {
          label: 'Create Date',
          key: 'create_date',
          sortable: false,
          tdClass: 'cnt',
          thClass: 'cnt',
        },
        {
          label: ' Action',
          key: '_id',
          sortable: false,
          thClass: 'cnt',
          tdClass: 'cnt',
        },
      ],
    }
  },
  mounted: function () {
    this.getList()
  },
  computed: {
    rows () {
      return this.data.length
    },
  },
  methods: {
    edit (data) {
      // this.visible = true
      var data1 = {}
      data1['name'] = data.item.name
      // evt.preventDefault()
      axios({
        method: 'POST',
        url: '/cites/edit/' + data.item._id,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data1,
      })
        .then((response) => {
          this.msg = response.data.msg
          if (response.data.status === true) {
            this.visible = false
            this.$bvToast.toast(this.msg, {
              title: `CITES`,
              solid: true,
              variant: 'success',
            })
          } else {
            this.visible = false
            this.$bvToast.toast(this.msg, {
              title: `CITES`,
              solid: true,
              variant: 'danger',
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    deleteCType (val) {
      this.visible = true
      if (confirm('Are you sure?')) {
        this.visible = true
        axios({
          method: 'POST',

          headers: {
            token: localStorage.getItem('token'),
          },
          url: '/cites/delete/' + val,
        })
          .then(response => {
            this.visible = false
            if (response.data.status) {
              this.getList()
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'success' })
            } else {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'error' })
            }
          })
          .catch(err => {
            this.visible = false
            this.errors.push(err)
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: 'error' }
            )
          })
      } else {
        this.visible = false
        this.$router.push({ name: 'cites' })
      }
    },
    onSubmit (evt) {
      // this.visible = true
      var data = {}
      data['name'] = this.name
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/cites/add',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(response => {
          this.msg = response.data.msg
          if (response.data.status) {
            this.visible = 'false'
            this.$dlg.alert(
              this.msg,
              () => {
                this.$bvModal.hide('modal-footer-sm')
                this.getList()
              },
              { messageType: 'success' }
            )
            this.$bvModal.hide('modal-footer-sm')
            this.getList()
          } else {
            this.$dlg.alert(
              this.msg,
              () => {
                this.$bvModal.hide('modal-footer-sm')
                this.getList()
              },
              { messageType: 'error' }
            )
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getList () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/cites/all/list',
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then(response => {
          // console.log(response.data.data)
          this.data = response.data.data
          for (var i = 0; i < this.data.length; i++) {
            var dt = this.data[i].create_date
            dt = new Date(dt)
            dt = dt.toString()
            dt = dt.slice(0, 15)
            this.data[i].create_date = dt
          }
          if (response.data.status === true) {
            this.data = response.data.data
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch(e => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>
<style>

.tablebutto {
  width: 21% !important;
  text-align: left;
}
</style>
